import React from "react"
import { OrgRouteComponentProps } from "../../RouteProps"
import { WorkerList } from "../../../Components/Views/Dashboard/Sections/Worker/WorkerList"
import { defaultWorkerSort } from "../../../Components/Views/Dashboard/Sections/Worker/Common/constants"
import { OrgAuthCheck } from "../../../Components/Common/AuthCheck/OrgAuthCheck"

export function WorkerAddRoute({ match }: OrgRouteComponentProps<{}>) {
    return (
        <OrgAuthCheck
            orgUsername={match.params.orgUsername}
            scope="worker:invite"
        >
            <WorkerList
                orgUsername={match.params.orgUsername}
                showAddModal={true}
                sort={defaultWorkerSort}
            />
        </OrgAuthCheck>
    )
}
